import * as React from 'react';
import * as _ from 'lodash';
import GoogleMapReact from 'google-map-react';
import { Link } from 'react-router-dom';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { fetchOneStoreWP, fetchStoreWP } from '../actions/posts';
import mapStateToProps from '../utils/mapStateToProps';
import mapDispatchToProps from '../utils/mapDispatchToProps';
import ListStore from './component/ListStore';
import StoreRelated from './component/StoreRelated';
import renderHTML from 'react-render-html';
import { isEmpty, mapOptions } from '../helpers/index';

class DetailStore extends React.Component<any, any> {

	constructor(props: any) {
		super(props);
		this.state = {
			loading: true
		}
	}

	componentDidMount() {
		if (this.props.match.params.post_id) {
			this.props.fetchOneStoreWP({
				post_id: this.props.match.params.post_id
			});
			this.props.fetchStoreWP({
				post_type: 'store',
				orderby: 'date',
				order: 'desc'
			});
		} else {
			this.props.history.push('/');
		}
	}

	componentWillReceiveProps(nextProps) {
		if(nextProps.match.params.post_id != this.props.match.params.post_id) {
			window.scrollTo(110, 110);
			this.setState({
				loading: true
			});
			nextProps.fetchOneStoreWP({
				post_id: nextProps.match.params.post_id
			});
		} else {
			if (nextProps.storeOneWP.loading == false && nextProps.storesWP.loading == false) {
				this.setState({
					loading: false
				})
			}
		}
	}

	shouldComponentUpdate(nextProps) {
		if (nextProps.storeOneWP.loading || nextProps.storesWP.loading) {
			return false;
		} else {
			return true;
		}
	}


	componentDidUpdate(prevProps, prevState) {
		if(isEmpty(prevProps.storeOneWP.data)) {
			document.title = this.props.t(prevProps.storeOneWP.data.post_title);
		}
	}


	render() {

		const { storeOneWP, storesWP, t } = this.props;

		var link = '';
		var address = '';
		var phone_number = '';
		var time_open = '';
		var lat = 16.2219471;
		var long = 105.2942988;
		let locationName = '';

		if (isEmpty(storeOneWP.data)) {
			link = storeOneWP.data.post_thumbnail.link;
			if (storeOneWP.data.custom_fields.length > 0) {
				address = storeOneWP.data.custom_fields[0]['value'];
				phone_number = storeOneWP.data.custom_fields[4]['value'];
				time_open = storeOneWP.data.custom_fields[5]['value'];
				lat = parseFloat(storeOneWP.data.custom_fields[2]['value']);
				long = parseFloat(storeOneWP.data.custom_fields[3]['value']);
			}
			if (storeOneWP.data.terms.length > 0) {
				var filterData = _.filter(storeOneWP.data.terms, post => {
					return post.slug == this.props.match.params.cate_slug
				});
				locationName = filterData[0]['name'];
			}
		}

		var category_slug = '';

		if (this.props.match.params.cate_slug) {
			category_slug = this.props.match.params.cate_slug;
		}

		let allRelatedStores = _.filter(storesWP.data, function (post) {
			return _.some(post.terms, { 'slug': category_slug, 'taxonomy': 'store_categories' });
		});

		let filteredStores = [];
		allRelatedStores.map((store) => {
			if (store.post_id != this.props.match.params.post_id && filteredStores.length < 3) {
				let storeHtml = <StoreRelated cate_slug={category_slug} key={store.post_id} store={store}/>;
				filteredStores.push(storeHtml);
			}
		});

		return (
			<div>
				<div className="bannerCover">
					<img src={require('../img/img-maskCover.png')}
					     style={{ background: `url(${link}) no-repeat center center/cover` }}/>
				</div>
				<div className="clearfix"/>
				<div className="backDetail">
					<div className="container">
						<div className="btn-backDetail ">
							<Link to="/stores" title="Go Back">
								<img src={require('../img/icon-back.png')} width={55}/> {t('back_page')}
							</Link>
						</div>
					</div>
				</div>
				<div className="clearfix"/>
				<div className="storeDetail">
					<div className="container">
						<div className="row">
							<div className="col-sm-8 columnLeft">
								<h3 className="entry-title">{storeOneWP.data.post_title}</h3>
								<section className="entry-content content-responsive middle-text postContent" id="shopContentInfo">
									{renderHTML(`${storeOneWP.data.post_content}`)}
								</section>
								<div className="related cityguide">
									<h3 className="entry-title">Cộng CàPhê tại {locationName}</h3>
									<div className="listStore">
										{filteredStores}
									</div>
								</div>
							</div>
							<div className="col-sm-4 columnRight ">
								<div className="sidebar">
									<h3 className="entry-title">{t('info_store')}</h3>
									<h4>{t('address_store')}:</h4>
									<div className="content">{address}</div>
									<div id="map" className="mt-4">
										<GoogleMapReact
											bootstrapURLKeys={{ key: process.env.REACT_APP_KEY_GOOGLE_MAP }}
											center={[lat, long]}
											defaultZoom={16}
											options={mapOptions}
										>
											<ListStore lat={lat} lng={long} img={require('../img/ico-markerStar.png')}/>
										</GoogleMapReact>
									</div>
									<div className="ui horizontal divider"/>
									<h4>{t('phone_store')}:</h4>
									<div className="content">{phone_number}</div>
									<div className="ui horizontal divider"/>
									<h4>{t('time_open_store')}:</h4>
									<div className="content">{time_open}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				{this.state.loading ? <div className="loadingPage active"> <img src={require('../img/Spin-1s-58px.gif')}/></div> : '' }
			</div>
		);
	}
}

export default connect(mapStateToProps([
	'storeOneWP', 'categoriesStoreWP', 'storesWP'
]), mapDispatchToProps({
	fetchOneStoreWP, fetchStoreWP
}))(translate('translations')(DetailStore));



// WEBPACK FOOTER //
// ./src/containers/DetailStore.tsx